
    <fieldmagic-checkbox-input
      class="w-100 h-100 d-flex align-items-center justify-content-center"
      [(ngModel)]="value"
      (ngModelChange)="onChanged()"
      [tooltip]="tooltip$ | async"
      [standalone]="true"
    >
    </fieldmagic-checkbox-input>
  